module.exports = __webpack_public_path__ + "static/media/sidebarline.ac61742c.svg";